import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'html2canvas';
import { memberPortal } from "../member-portal";

export class memberRegisterForm {
	private registerSuccess:any   = $('#enrich-register-success');
	private memberBase:any = new memberPortal();

	initPrintCard(): any {
		let _self = this;
		let saveCardBtn = _self.registerSuccess.find('#enrich-register-save-card');
		let printCardBtn = _self.registerSuccess.find('#enrich-register-print-card');
		let cardImage = _self.registerSuccess.find('.members--card-image');
		let cardAspectRatio = 273/137;
		let temporaryCard = _self.registerSuccess.find('.temporary-card');

		printCardBtn.on('click', (e:any) => {
			e.preventDefault();
			e.stopPropagation();

			html2canvas(cardImage[0], {
				onrendered: function(canvas:any) {
					let nW:any = window.open('','','width=600,height=400');
					nW.document.write('<img src="'+canvas.toDataURL()+'"/>');
					nW.focus();
					setTimeout(() => {
						nW.print();
						nW.close();
					}, 600);
				}
			});
		});

		saveCardBtn.on('click', (e:any) => {
			e.preventDefault();
			e.stopPropagation();

			html2canvas(cardImage[0], {
				onrendered: function(canvas:any) {
					temporaryCard
					.append('<a class="hidden" id="temp-card-image-for-dl" href="'+canvas.toDataURL()+'" download="member-card.png">Download</a>');

					let tempDlBtn = $('#temp-card-image-for-dl');

					tempDlBtn[0].click();
				}
			});
		});
	}
}

let scope:Element = document.querySelector('#enrich-register-success');

if (scope) {
	try {
		let memberregisterform = new memberRegisterForm();
		memberregisterform.initPrintCard();
	} catch(e) {console.error(e);}
}
